module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "login",
    style: (_vm.bg_style)
  }, [_c('div', {
    staticClass: "loform"
  }, [_c('header', [_vm._v("亿用ERP管理系统")]), _vm._v(" "), (!_vm.showQrcode) ? _c('el-form', {
    ref: "formData",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    staticClass: "change-opacity",
    attrs: {
      "size": "medium",
      "placeholder": "登录账号"
    },
    model: {
      value: (_vm.formData.username),
      callback: function($$v) {
        _vm.$set(_vm.formData, "username", $$v)
      },
      expression: "formData.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password_hash"
    }
  }, [_c('el-input', {
    staticClass: "change-opacity",
    attrs: {
      "type": "password",
      "size": "medium",
      "placeholder": "登录密码"
    },
    model: {
      value: (_vm.formData.password_hash),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password_hash", $$v)
      },
      expression: "formData.password_hash"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "verification-code",
    attrs: {
      "prop": "ding_verification_code"
    }
  }, [_c('el-input', {
    staticClass: "change-opacity",
    attrs: {
      "size": "medium",
      "placeholder": "验证码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loginBtn($event)
      }
    },
    model: {
      value: (_vm.formData.ding_verification_code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ding_verification_code", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formData.ding_verification_code"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "change-opacity2",
    attrs: {
      "size": "medium",
      "disabled": !_vm.show
    },
    on: {
      "click": function($event) {
        return _vm.getCode(_vm.formData)
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }]
  }, [_vm._v("获取验证码")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.count) + " s")])])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "login-btn",
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.loginBtn
    }
  }, [_vm._v("登录")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showQrcode),
      expression: "showQrcode"
    }],
    attrs: {
      "id": "qrCodeContainer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "qr_code",
    on: {
      "click": _vm.changeForm
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showQrcode),
      expression: "showQrcode"
    }],
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showQrcode),
      expression: "!showQrcode"
    }],
    staticClass: "iconfont"
  }, [_vm._v("")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "record"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": "http://www.beian.miit.gov.cn"
    }
  }, [_vm._v(_vm._s(_vm.recordNumber))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f19d350","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/login.vue
// module id = jo9J
// module chunks = 511